<template>
  <div :class="{ 'nav-open': $sidebar.showSidebar }">
    <ToastNotification />
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ToastNotification from "@/components/Notifications/ToastNotification.vue";
export default {
  components: {
    ToastNotification
  },
  computed: {
    ...mapGetters({
      selectedDroit: "selectedDroit",
      homePageRouteObject: "homePageRouteObject",
      getNotificationMessageArray: "getNotificationMessageArray",
      notificationTextMessage: "notificationTextMessage",
      notificationJsonMessage: "notificationJsonMessage",
      notificationTitle: "notificationTitle",
      notificationIcon: "notificationIcon",
      notificationType: "notificationType",
      textNotificationCount: "textNotificationCount",
      jsonNotificationCount: "jsonNotificationCount"
    })
  },
  watch: {
    textNotificationCount() {
      this.addTextNotification();
    },
    jsonNotificationCount() {
      this.addJsonNotification();
    }
  },
  created() {
    this.initialRedirection();
  },
  methods: {
    initialRedirection() {
      if (!this.selectedDroit || this.selectedDroit.role == "") {
        this.$router.push(this.homePageRouteObject).catch(err => {});
      }
    },
    addTextNotification() {
      this.$notify({
        message: this.notificationTextMessage,
        icon: this.notificationIcon,
        horizontalAlign: "right",
        verticalAlign: "top",
        type: this.notificationType
      });
    },
    addJsonNotification() {
      this.$notify({
        title: this.notificationTitle,
        icon: this.notificationIcon,
        horizontalAlign: "right",
        verticalAlign: "top",
        type: this.notificationType,
        notificationJsonMessage: this.notificationJsonMessage,
      });
    }
  }
};
</script>

<style lang="scss">
.vue-notifyjs.notifications {
  .alert {
    z-index: 10000;
    span[data-notify="message"] {
      padding: 10px 0;
    }
  }
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
  .leaflet-fade-anim .leaflet-tile,
  .leaflet-zoom-anim .leaflet-zoom-animated {
    will-change: auto !important;
  }
}
</style>
